import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const superAdminClubManagementRoutes = [
  {
    path: 'clubs',
    component: DummyRouter,
    meta: {
      layoutPadding: false,
      permissionAction: PermissionActions.SuperAdminLimitedClubsView,
    },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/superAdmin/clubManagement/list/SuperAdminClubManagementListView.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedClubsView,
        },
      },
      {
        path: ':clubId/codes/:id',
        component: () => import('@/features/superAdmin/tenantCodes/TenantCodeDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsCodesView,
        },
      },
      {
        path: ':clubId/groups/:id',
        component: () => import('@/features/superAdmin/tenantGroups/TenantGroupDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsGroupsView,
        },
      },
      {
        path: ':clubId/terms/:id',
        component: () => import('@/features/superAdmin/tenantTerms/TenantTermDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsTermsView,
        },
      },
      {
        path: ':clubId/term-groups/:id',
        component: () => import('@/features/superAdmin/tenantTermGroups/TenantTermGroupDetail.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsTermGroupsView,
        },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/superAdmin/clubManagement/edit/SuperAdminClubManagementEditView.vue'),
        meta: {
          fullSuperAdminOnly: true,
        },
      },
      {
        path: ':clubId/people',
        component: () => import('@/features/peopleManagement/PeopleManagementContextHost.vue'),
        meta: {
          layoutPadding: false,
          permissionAction: PermissionActions.SuperAdminLimitedClubsPeopleView,
        },
        children: [
          {
            path: 'new',
            component: () => import('@/features/peopleManagement/new/PeopleNewView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedClubsPeopleCreate,
            },
          },
          {
            path: ':personId',
            component: () => import('@/features/peopleManagement/view/PeopleView.vue'),
            meta: {
              permissionAction: PermissionActions.SuperAdminLimitedClubsPeopleView,
            },
            children: [
              {
                path: '',
                redirect: to => ({
                  path: `/super-admin/clubs/${to.params.clubId}/people/${to.params.personId}/details`,
                  query: to.query,
                }),
              },
              {
                path: 'details',
                component: () =>
                  import('@/features/peopleManagement/view/details/PeopleViewDetailsV2.vue'),
                meta: {
                  permissionAction: PermissionActions.SuperAdminLimitedClubsPeopleView,
                },
              },
            ],
          },
        ],
      },
      {
        path: ':clubId',
        component: () =>
          import('@/features/superAdmin/clubManagement/edit/SuperAdminClubManagementEditView.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedClubsView,
        },
      },
    ],
  },
]
